import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <button
        type="button"
        className="hamburger"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Toggle menu"
        aria-expanded={open}
      >
        {"\u2630"}
      </button>

      <div className="nav-quick-links">
        <NavLink className="nav-item quiz-zone-pin" to="/quiz-zone" onClick={() => setOpen(false)}>
          Quiz Zone
        </NavLink>
        <NavLink className="nav-item test-series-pin" to="/test-series" onClick={() => setOpen(false)}>
          Test Series
        </NavLink>
      </div>

      <ul className={`nav-links ${open ? "active" : ""}`}>
        <li><NavLink className="nav-item" to="/" onClick={() => setOpen(false)}>Home</NavLink></li>
        <li><NavLink className="nav-item" to="/latest-jobs" onClick={() => setOpen(false)}>Latest Jobs</NavLink></li>
        <li><NavLink className="nav-item" to="/admit-card" onClick={() => setOpen(false)}>Admit Card</NavLink></li>
        <li><NavLink className="nav-item" to="/results" onClick={() => setOpen(false)}>Results</NavLink></li>
        <li><NavLink className="nav-item" to="/admission" onClick={() => setOpen(false)}>Admission</NavLink></li>
        <li><NavLink className="nav-item" to="/answer-key" onClick={() => setOpen(false)}>Answer key</NavLink></li>
        <li><NavLink className="nav-item" to="/syllabus" onClick={() => setOpen(false)}>Syllabus</NavLink></li>
        <li className="test-series-list-item">
          <NavLink className="nav-item" to="/test-series" onClick={() => setOpen(false)}>
            Test Series
          </NavLink>
        </li>
        <li className="quiz-zone-list-item">
          <NavLink className="nav-item" to="/quiz-zone" onClick={() => setOpen(false)}>
            Quiz Zone
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
